import { Directive, OnInit, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, Observable, take } from 'rxjs';
import { StepComponent } from '@toevla-webapplications/core';

@Directive()
export abstract class ProgressWizardComponent implements OnInit {
	showError: boolean;
	step$: Observable<number>;
	stepNames = signal<string[]>([]);

	constructor(
		protected translate: TranslateService,
		private STEP_NAMES: string[]
	) {}

	ngOnInit() {
		forkJoin(this.STEP_NAMES.map((name) => this.translate.get(name))).subscribe((names) => {
			this.stepNames.set(names);
		});
	}

	goToStep(step: number) {
		this.showError = false;

		this.getCurrentStepComponent().subscribe((stepComponent) => {
			stepComponent?.save();

			this.updateStep(step);
		});
	}

	finish() {
		this.showError = false;

		this.getCurrentStepComponent().subscribe((stepComponent) => {
			stepComponent?.save();

			if (stepComponent?.isValid()) {
				this.scrollToTop();
				this.whenFinished();
			}
		});
	}

	next() {
		this.showError = false;

		this.getCurrentStepComponent().subscribe((stepComponent) => {
			stepComponent?.save();
			this.scrollToTop();

			this.showError = !stepComponent?.isValid();

			if (!this.showError) {
				this.step$.pipe(take(1)).subscribe((step) => this.updateStep(step + 1));
			}
		});
	}

	previous() {
		this.showError = false;

		this.getCurrentStepComponent().subscribe((stepComponent) => {
			stepComponent?.save();
			this.scrollToTop();

			this.step$.pipe(take(1)).subscribe((step) => this.updateStep(step - 1));
		});
	}

	protected abstract getCurrentStepComponent(): Observable<StepComponent | null>;

	protected abstract updateStep(step: number): void;

	protected abstract whenFinished(): void;

	private scrollToTop() {
		window.scrollTo(0, 0);
	}
}
